import { FormLabel, makeStyles, TextField } from '@material-ui/core';
import styles from '../customTextField/CustomTextField.module.scss';
import React from 'react';
import clsx from 'clsx';
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import dayjs from 'dayjs';
const CustomDateField = ({
	value,
	name,
	onChange,
	error,
	errorMessage,
	formLabel,
	required,
	minDate,
	maxDate,
	disableFuture,
	disablePast,
}) => {
	const useStyles = makeStyles((theme) => ({
		inputLabel: {
			color: 'var(--text-mid-emphasis)',
			fontSize: 'var(--text-size-small)',
			marginBottom: '10px',
			marginLeft: '5px',
		},
		calendarIcon: {
			'&::-webkit-calendar-picker-indicator': {
				filter: 'invert(48%) sepia(98%) saturate(3020%) hue-rotate(204deg) brightness(105%) contrast(99%)',
				cursor: 'pointer',
				marginRight: '10px',
			},
		},
		dateField: {
			boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
			height: '44px',
			padding: '0px',
			width: '100%',
			'&.MuiInputBase-input:invalid': {
				// boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
			},
			'& .MuiInput-underline:before': {
				borderBottom: 'none !important',
			},
			'& .MuiInput-underline:hover:before': {
				borderBottom: 'none !important',
			},
			'& .MuiInput-underline:after': {
				borderBottom: 'none !important',
			},
			'& input': {
				height: 30,
			},
			'& button': {
				// calendar icon button
				color: '#438afe',
				padding: 8,
			},
			'& p': {
				// helper text
				width: 250,
			},
		},
	}));
	const classes = useStyles();

	return (
		<div className={styles.textFieldWrapper}>
			<FormLabel className={classes.inputLabel}>
				{formLabel} {formLabel && required && '*'}
			</FormLabel>
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<KeyboardDatePicker
					className={clsx(
						classes.dateField,
						error && !errorMessage ? styles.error : null
					)}
					value={value}
					name={name}
					onChange={(date) =>
						onChange({
							value: dayjs(date).format('YYYY-MM-DD'),
							name,
						})
					}
					format='yyyy-MM-dd'
					minDate={minDate ? new Date(minDate) : undefined}
					maxDate={maxDate ? new Date(maxDate) : undefined}
					disableFuture={disableFuture === true ? true : false}
					disablePast={disablePast === true ? true : false}
					emptyLabel='yyyy-mm-dd'
				/>
			</MuiPickersUtilsProvider>
			<span
				className={styles.formHelper_error}
				style={
					error === true
						? {
								display: 'block',
						  }
						: {
								display: 'none',
						  }
				}
			>
				{errorMessage}
			</span>
		</div>
	);
};

export default CustomDateField;
